var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:['base-button', _vm.buttonClass, _vm.transparentClass],attrs:{"type":_vm.type,"disabled":_vm.disable,"size":_vm.size,"plain":_vm.plain,"round":_vm.round,"circle":_vm.circle,"loading":_vm.loading,"icon":_vm.icon},on:{"click":_vm.buttonClick}},[_vm._t("default"),_vm._v(_vm._s(_vm.label)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }